export const defaultNS = "common";

export const supportedLngs = ["en", "es", "fr", "de"] as const;

export const defaultLng: (typeof supportedLngs)[number] = "en";

export const fallbackLng: (typeof supportedLngs)[number] = "en";

export const resources = {
  en: {
    common: () => import("./locales/en/common.json"),
    landing: () => import("./locales/en/landing.json"),
    about: () => import("./locales/en/about.json"),
    legal: () => import("./locales/en/legal.json"),
  },
  es: {
    common: () => import("./locales/es/common.json"),
    landing: () => import("./locales/es/landing.json"),
    about: () => import("./locales/es/about.json"),
  },
  fr: {
    common: () => import("./locales/fr/common.json"),
    landing: () => import("./locales/fr/landing.json"),
    about: () => import("./locales/fr/about.json"),
  },
  de: {
    common: () => import("./locales/de/common.json"),
    landing: () => import("./locales/de/landing.json"),
    about: () => import("./locales/de/about.json"),
    legal: () => import("./locales/de/legal.json"),
  },
} as const;

export type Language = (typeof supportedLngs)[number];
export type Namespace = keyof (typeof resources)[typeof defaultLng];
